import React from 'react';
import { Button, Card } from 'react-bootstrap';

/**
 * Motivo do bloqueio define o texto e a ação.
 *
 * Inadimplência tem saída pelas mãos do próprio cliente (pagar). Contrato encerrado e
 * isenção vencida não: nesses casos oferecer "Pagar agora" apontaria para uma cobrança
 * antiga que não devolve o acesso.
 */
const CONTENT_BY_REASON = {
    BLOCKED: {
        icon: 'fa-lock text-warning',
        title: 'Acesso temporariamente bloqueado',
        description: 'Identificamos uma cobrança SaaS em aberto. Regularize o pagamento para liberar o acesso à plataforma.',
        allowPayment: true,
    },
    CANCELED: {
        icon: 'fa-circle-xmark text-danger',
        title: 'Contrato encerrado',
        description: 'O contrato desta empresa foi cancelado e o acesso à plataforma está encerrado. Fale com o administrador para reativar.',
        allowPayment: false,
    },
    EXEMPT: {
        icon: 'fa-hourglass-end text-warning',
        title: 'Período de isenção encerrado',
        description: 'A isenção concedida a esta empresa chegou ao fim. Fale com o administrador da plataforma para definir o novo plano.',
        allowPayment: false,
    },
};

const SaaSBlockedPage = () => {
    let details = {};
    try {
        details = JSON.parse(sessionStorage.getItem('saas_blocked_details') || '{}');
    } catch (error) {
        details = {};
    }

    // Resposta antiga, sem motivo, era sempre inadimplência.
    const content = CONTENT_BY_REASON[details.reason] || CONTENT_BY_REASON.BLOCKED;

    return (
        <div className="container py-5">
            <Card className="border-0 shadow-sm mx-auto" style={{ maxWidth: 620 }}>
                <Card.Body className="p-4 p-md-5 text-center">
                    <i className={`fa-solid ${content.icon} fs-1 mb-3`} />
                    <h3>{content.title}</h3>
                    <p className="text-muted mb-4">{details.message || content.description}</p>
                    {content.allowPayment && details.paymentLink ? (
                        <Button variant="primary" href={details.paymentLink} target="_blank" rel="noreferrer">
                            <i className="fa-solid fa-qrcode me-2" />Pagar agora
                        </Button>
                    ) : (
                        <p className="text-muted mb-0">
                            {content.allowPayment
                                ? 'Solicite o link de pagamento ao administrador da plataforma.'
                                : 'Entre em contato com o administrador da plataforma.'}
                        </p>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};

export default SaaSBlockedPage;
